import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValueMatrixTableRequest } from '../../Refactor/Pages/Calculators/ValueMatrixCalculator/ValueMatrixDefinitions';
import type { RootState } from '../ReduxStore';

const initialState: ValueMatrixTableRequest = {} as ValueMatrixTableRequest;

export const valueMatrixCalculatorSlice = createSlice({
    name: 'valueMatrix',
    initialState,
    reducers: {
        setValueMatrixTableInputsRequest: (state: ValueMatrixTableRequest, action: PayloadAction<ValueMatrixTableRequest>): void => {
            state.asOfDate = action.payload.asOfDate;
            state.product = action.payload.product;
            state.market = action.payload.market;
            state.stripType = action.payload.stripType;
            state.termClassification = action.payload.termClassification ?? [];
            state.timeSpan = action.payload.timeSpan;
            state.applyProducerPriceIndex = action.payload.applyProducerPriceIndex;
            state.showWeightedFields = action.payload.showWeightedFields;
            state.weighted = action.payload.weighted;
            state.updateTriggeredBy = action.payload.updateTriggeredBy;
            state.isCascadeUpdating = action.payload.isCascadeUpdating;
        },
    },
});

export const { setValueMatrixTableInputsRequest } = valueMatrixCalculatorSlice.actions;

export const selectValueMatrixTableInputsRequest = (state: RootState): ValueMatrixTableRequest => state.valueMatrix;

export default valueMatrixCalculatorSlice.reducer;
